import type { Question } from "@/types/jben/job_post.ts";
import RailsUploader from "./rails_uploader";

export type Field = "resume" | "cover_letter" | string;
export type Fields = Field[];

type Uploaders = Record<Field, RailsUploader>;

export default class UploadManager {
  uploaders: Uploaders;

  constructor() {
    this.uploaders = {} as Uploaders;
  }

  inputFilesFrom(questions: Question[]) {
    if (!questions) return [];
    return questions.reduce((memo: Fields, question) => {
      question.fields.forEach((field) => {
        if (field.type === "input_file") memo.push(field.name);
      });
      return memo;
    }, []);
  }

  initUploaders(fields: Fields) {
    fields.forEach((field) => {
      this.uploaders[field] = new RailsUploader({ field });
    });
  }
}
